module.exports = __webpack_public_path__ + "static/img/background.b3085a42.jpg";